
import HomeContainer from '../containers/HomeContainer/HomeContainer';

const Home = () => <HomeContainer />;

export default Home;
